import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const VIIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="VI" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#E8AA00"
          d="M8.933 7.418s.305.13.305.303c0 .172.516.609.517.78 0 .171-.45.585-.636.769-.186.183-.43.537-.623.537-.194 0-.316.258-.48.258-.004 0-.007-.003-.011-.007-.004.004-.008.007-.012.007-.164 0-.287-.258-.48-.258-.194 0-.438-.354-.624-.537-.186-.184-.634-.598-.634-.769 0-.171.515-.608.515-.78 0-.17.297-.3.305-.303l.918-.387.01.242.013-.242.917.387Zm-1.89-.11s-.525-.029-.525.363c0 .391-.481.57-.75.57-.27 0-.419.176-.419.487 0 .31-.55.12-.682 0s.131-.637.268-.637.293-.107.584-.107.03-.38.331-.88c.294-.49.56-.68.572-.688l.622.892Zm2.649-.892c.012.008.278.198.571.688.3.5.04.88.331.88.291 0 .447.107.584.107.137 0 .4.517.269.637-.132.12-.683.31-.683 0 0-.311-.148-.488-.418-.488s-.75-.178-.75-.57c0-.39-.526-.362-.526-.362l.622-.892ZM1.388 2.435c.247-.106 4.056 1.131 4.258 1.132.2 0 .574.483.387.686-.188.203-.25.322-.125.322.124 0 .744-.16.758-.164v1.886c-.012.003-.608.142-.758 0-.152-.144-.468-.009-.469-.165 0-.154-.336-.18-.349-.182 0 0-.322-.107-.323-.207 0-.099-.205-.375-.212-.384 0 0-.806-.457-1.492-.958-.685-.5-1.332-.858-1.428-1.29-.358-.354-.493-.57-.247-.676Zm13.337 0c.247.106.111.322-.247.676-.096.432-.742.79-1.428 1.29-.685.501-1.492.958-1.492.958-.005.008-.212.285-.212.384 0 .1-.323.207-.323.207-.011.001-.35.028-.35.182 0 .156-.316.021-.467.165-.15.142-.744.003-.758 0V4.41c.015.004.634.164.758.164.125 0 .062-.119-.125-.322-.188-.203.187-.686.386-.686.203 0 4.011-1.238 4.258-1.132ZM8.038 2.4c.392 0 .535.469.536.562 0 .092.132.576.134.583-.009 0-.134.002-.134.063.001.063.41.33.42.336 0 0-.314.094-.193.162.06.035.109.096.142.149l-1.992.097.14-.246c-.007-.003-.138-.064-.069-.064.071 0 .274-.284.274-.284H7.21c-.003-.005-.039-.07.085-.07.125-.001.226-.444.229-.458 0 0 .084-.214-.121-.268-.202-.053-.444.17-.453.179.002-.015.061-.374.14-.454.081-.08.313-.015.313-.113s.241-.174.634-.174Z"
        />
        <Path
          fill="#46A000"
          d="M4.36 6.087c.163-.164.14 0 .14.151s-.282.42-.367.42H4.13c.073.14.15.283.23.425-.005-.079.035-.212.035-.212.003-.005.066-.14.227-.302.164-.163.141 0 .141.15 0 .152-.283.421-.368.422l-.006-.003c.057.101.117.202.175.301.01-.058.027-.113.029-.118 0 0 .062-.138.226-.302.164-.164.142 0 .142.15 0 .13-.205.342-.319.403l.134.226.015-.06a1.16 1.16 0 0 1 .226-.301c.164-.164.14 0 .14.15 0 .115-.162.297-.277.379l.094.15.014-.056c.004-.008.067-.143.227-.302.164-.164.141 0 .141.151 0 .114-.16.294-.276.376.384.603.687 1.034.687 1.034h-.352c-.175-.109-.42-.542-.674-1.084-.038.02-.095.04-.15.06-.143.052-.492-.121-.521-.201-.028-.079.244-.092.253-.092 0 0 .151.011.361.11l-.102-.227c-.02.034-.106.06-.189.09-.142.051-.491-.123-.52-.203-.03-.08.253-.091.253-.091.005 0 .155.013.361.109a.36.36 0 0 1 .074.045 35.488 35.488 0 0 1-.68-1.69c.066.145.137.296.214.448a.846.846 0 0 1 .037-.203s.062-.14.226-.303Zm-.432 1.176s.152.011.362.11c.21.097.049.132-.093.184-.142.051-.491-.123-.52-.203-.028-.077.24-.09.251-.091Zm-.197-.45s.151.011.362.11c.21.098.048.133-.094.184-.142.052-.491-.122-.52-.202-.03-.079.246-.091.252-.092Zm-.165-.45s.151.011.361.11c.21.098.05.133-.092.184-.142.052-.492-.122-.52-.202-.03-.078.24-.091.251-.092Zm-.347-.54c0-.086.269 0 .269 0 .009.003.143.067.302.226.163.164 0 .14-.152.14-.15 0-.419-.281-.42-.367Zm.787-.257c.098-.21.133-.048.184.094.052.142-.122.492-.202.52-.08.03-.092-.252-.092-.252 0-.008.014-.157.11-.362Zm-.5-.23c-.02-.231.09-.108.206-.01.115.096.14.486.085.551-.004.004-.009.003-.013.005l.099.263a7.13 7.13 0 0 1-.11-.257c-.066-.003-.182-.184-.182-.184a1.169 1.169 0 0 1-.085-.368Z"
        />
        <Path
          fill="#0093E1"
          d="m11.098 9.054-.086.076.17.125-.253 1.126-.338-.293-.355.163v-.163l-.18.163-.136-.461h-.39l.706-.82h.25v-.24h.526l.086.324Zm1.261-2.476-.151-.134-.899 1.676 1.002-1.148-.192-.097.99-.648-.431 1.056-.24-.174-1.018 1.282-.422-.162.422-1.501h-.286l.572-1.055.018 1.174-.178-.058-.126.784.634-1.215-.211-.079.784-.848-.268 1.147Zm1.987-1.41c-.01.003-.278.054-.278.22V7.38c.002.005.053.19.278.194.227.004-1.069 0-1.069 0s.247-.049.252-.194c.005-.145 0-1.992 0-1.992-.025-.22-.252-.22-.252-.22h1.069Zm-12.192.034c-.127 0-.175.161-.176.163l.518 1.477s.5-1.204.501-1.42c0-.208-.2-.22-.21-.22h.964l-.234.077s-.77 1.767-.771 2.147c-.037.084.355.14.355.14H2.066l.217-.14-.868-2.224h.74Z"
        />
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M6.172 4.006s.465.322.93.322c.466 0 .931-.322.931-.322s.465.322.93.322c.466 0 .931-.322.931-.322v1.45c0 1.5-1.861 2.663-1.861 2.663s-1.951-1.067-1.861-2.68V4.006Z"
          clipRule="evenodd"
        />
        <Mask
          id="c"
          width={4}
          height={5}
          x={6}
          y={4}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <Path
            fill="#fff"
            fillRule="evenodd"
            d="M6.172 4.006s.465.322.93.322c.466 0 .931-.322.931-.322s.465.322.93.322c.466 0 .931-.322.931-.322v1.45c0 1.5-1.861 2.663-1.861 2.663s-1.951-1.067-1.861-2.68V4.006Z"
            clipRule="evenodd"
          />
        </Mask>
        <G mask="url(#c)">
          <Path
            fill="#2E42A5"
            fillRule="evenodd"
            d="M6.04 3.91h3.92v1.51H6.04V3.91Z"
            clipRule="evenodd"
          />
          <Path
            fill="#AF0100"
            d="M6.797 8.472h-.329V5.42h.33v3.052Zm.56 0h-.33V5.42h.33v3.052Zm.56 0h-.329V5.42h.33v3.052Zm.561 0h-.33V5.42h.33v3.052Zm.56 0h-.33V5.42h.33v3.052Zm.56 0h-.33V5.42h.33v3.052Z"
          />
        </G>
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
